<h1 mat-dialog-title>Enable Timeline as Basic</h1>
<div mat-dialog-content>
  <p>You are attempting to enable BASIC property on this Timeline but it contains <span *ngIf="data.count>1">{{data.count}} non-BASIC Exercises</span><span *ngIf="data.count===1">one non-BASIC Exercise</span>. If you proceed, all included Exercises <strong>WILL BE ENABLED AS BASIC</strong> too.</p>  
</div>
<div mat-dialog-actions fxLayoutAlign="space-between stretch">
  <button mat-button [mat-dialog-close]>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes, proceed</button>
</div>